var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSwapIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 17,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7D7D7D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.61 1.775a3.998 3.998 0 0 1 3.979 3.676l-.833-.833a.466.466 0 1 0-.66.66l1.646 1.646a.465.465 0 0 0 .66 0l1.646-1.646a.466.466 0 1 0-.66-.66l-.864.864A4.93 4.93 0 0 0 9.609.842a.466.466 0 1 0 0 .933zM8.102 14.041a3.998 3.998 0 0 1-3.98-3.676l.834.834a.465.465 0 0 0 .66 0 .466.466 0 0 0 0-.66L3.971 8.893a.466.466 0 0 0-.66 0l-1.646 1.646a.466.466 0 1 0 .66.66l.864-.865a4.93 4.93 0 0 0 4.914 4.64.466.466 0 1 0 0-.933zM3.89 1.252a2.774 2.774 0 1 0 0 5.548 2.774 2.774 0 0 0 0-5.548zm0 .95a1.823 1.823 0 1 1 0 3.648 1.823 1.823 0 0 1 0-3.647zM14.322 8.989a2.774 2.774 0 1 0 0 5.547 2.774 2.774 0 0 0 0-5.547zm0 .95a1.823 1.823 0 1 1 0 3.647 1.823 1.823 0 0 1 0-3.647z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSwapIcon);
export default ForwardRef;